import axios from "axios";
import { createPaginatedStateWithSummary, createPaginatedState, handlePaginatedResponse } from '../helpers/paginationState';

export const state = {
    save_status: false,
    filter_status: false,
    recipes: [],
    recipes_cart: [],
    expected_output: createPaginatedState(),
    actual_output: createPaginatedState(),
    production_order_cart: [],
    production_orders: createPaginatedStateWithSummary(50),
};
export const getters = {
    SaveStatus: state => state.save_status,
    filterStatus: state => state.filter_status,
    Recipes: state => state.recipes.data,
    RecipesCart: state => state.recipes_cart.data,
    ExpectedOutput: state => state.expected_output.data,
    ExpectedOutputPagination: state => state.expected_output.meta,
    IsExpectedOutputServerPaginated: state => state.expected_output.isServerPaginated,
    ActualOutput: state => state.actual_output.data,
    ActualOutputPagination: state => state.actual_output.meta,
    IsActualOutputServerPaginated: state => state.actual_output.isServerPaginated,
    ProductionOrderCart: state => state.production_order_cart.data,
    ProductionOrders: state => state.production_orders.data,
    ProductionOrdersPagination: state => state.production_orders.meta,
};

export const mutations = {
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_FILTER_STATUS(state, newValue) {
        state.filter_status = newValue
    },
    SET_RECIPE(state, newValue) {
        state.recipes = newValue
    },
    SET_RECIPE_CART(state, newValue) {
        state.recipes_cart = newValue
    },
    SET_EXPECTED_OUTPUT(state, response) {
        handlePaginatedResponse(state.expected_output, response);
    },
    SET_ACTUAL_OUTPUT(state, response) {
        handlePaginatedResponse(state.actual_output, response);
    },
    SET_PRODUCTIONORDER_CART(state, newValue) {
        state.production_order_cart = newValue
    },
    SET_PRODUCTION_ORDERS(state, response) {
        handlePaginatedResponse(state.production_orders, response);
    },
    RESET_PRODUCTION_ORDERS_PAGINATION(state) {
        state.production_orders.data = [];
        state.production_orders.meta = { current_page: 1, from: 1, last_page: 1, per_page: 50, to: 0 };
    },
};

export const actions = {

    // Recipes Cart
    fetchRecipesCart({ commit }) {
        axios.get(`recipes_cart`).then(ec_res => {
            commit('SET_RECIPE_CART', ec_res.data)
        })
    },

    addToRecipesCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('recipes_cart', payload).then(() => {
            dispatch('fetchRecipesCart');
            let message = { 'msg': `Ingredient added to cart successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Ingredient to cart " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    editRecipesCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`recipes_cart/${payload.id}`, payload).then(() => {
            dispatch('fetchRecipesCart');
            let message = { 'msg': `Ingredient ${payload.name} in cart updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error on updating Recipe Item in cart" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteRecipesCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`recipes_cart/${payload.id}`).then(() => {
            dispatch('fetchRecipesCart');
            let message = { 'msg': `Ingredient ${payload.name} deleted from cart successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_RECIPE_CART', false)
            let message = { 'msg': "Error on deleting Ingredient from cart " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchRecipes({ commit }, payload) {
        axios.post(`fetchingredients`, payload).then(ec_res => {
            commit('SET_RECIPE', ec_res.data)
        })
    },

    addRecipes({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('recipes', payload).then((res) => {
            if (res.data.status == 200) {
                dispatch('fetchRecipesCart');
                let message = { 'msg': `Ingredients for Item ${payload.name} added successfully` }
                dispatch('notification/success', message, { root: true })
            } else {
                let message = { 'msg': res.data.message };
                dispatch('notification/error', message, { root: true })
            }
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Ingredients" }
            dispatch('notification/error', message, { root: true })
        })
    },
    editRecipes({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`recipes/${payload.id}`, payload).then(() => {
            dispatch('fetchRecipes');
            let message = { 'msg': `Ingredient ${payload.recipe} for product ${payload.product} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Ingredient" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteRecipes({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`recipes/${payload.id}`).then(() => {
            dispatch('fetchRecipes');
            let message = { 'msg': `Ingredient ${payload.recipe} for product ${payload.product} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in deleting Ingredient" }
            dispatch('notification/error', message, { root: true })
        })
    },
    async editProductQuantity({ commit, dispatch }, payload) {
        commit("SET_SAVE_STATUS", true);
        await axios.put(`/recipes/products/${payload.product_id}`, payload).then(() => {
            dispatch('fetchRecipes');
            let message = { 'msg': `Product quantity updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Product Quantity" }
            dispatch('notification/error', message, { root: true })
        });
    },

    changeBase({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`change_base/${payload.id}`, payload).then(() => {
            dispatch('fetchRecipes');
            let message = { 'msg': `Ingredient ${payload.recipe} has been set as base for product ${payload.product}` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in setting base Ingredient" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchExpectedOutput({ commit }, payload = {}) {
        commit('SET_FILTER_STATUS', true);

        const filters = payload || {};

        axios.post(`fetch_expectedoutput`, filters)
            .then(ec_res => {
                commit('SET_FILTER_STATUS', false);
                commit('SET_EXPECTED_OUTPUT', ec_res.data)
            })
            .catch(() => {
                commit('SET_EXPECTED_OUTPUT', { data: [], meta: {} });
                commit('SET_FILTER_STATUS', false);
            });
    },


    fetchActualOutput({ commit, dispatch }, payload = {}) {
        commit('SET_FILTER_STATUS', true);

        const filters = payload || {};

        axios.post(`fetch_actualoutput`, filters)
            .then(res => {
                commit('SET_FILTER_STATUS', false);
                commit('SET_ACTUAL_OUTPUT', res.data);
            })
            .catch(() => {
                commit('SET_ACTUAL_OUTPUT', {
                    data: [],
                    meta: {}
                });
                commit('SET_FILTER_STATUS', false);
                dispatch(
                    'notification/error',
                    { msg: 'Failed to load actual output.' },
                    { root: true }
                );
            });
    },


    editOutput({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`expected_output/${payload.id}`, payload).then(() => {
            dispatch('fetchExpectedOutput', payload.filters);
            let message = { 'msg': `Output for product ${payload.product} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Output" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteOutput({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`expected_output/${payload.id}`).then(() => {
            dispatch('fetchExpectedOutput', payload.filters);
            let message = { 'msg': `Output for product ${payload.product} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in deleting Output" }
            dispatch('notification/error', message, { root: true })
        })
    },

    confirmOutput({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('expected_output', payload).then(() => {
            dispatch('fetchExpectedOutput', payload.expectedFilters);
            dispatch('fetchActualOutput', payload.actualFilters);
            let message = { 'msg': `Output for product ${payload.product} cofirmed successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in cofirming Output" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Production Order Cart
    fetchProductionOrderCart({ commit }) {
        axios.get(`productionorder_cart`).then(ec_res => {
            commit('SET_PRODUCTIONORDER_CART', ec_res.data)
        })
    },

    addToProductionOrderCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('productionorder_cart', payload).then((res) => {
            if (res.status == 200) {
                dispatch('fetchProductionOrderCart');
                let message = { 'msg': `Item added to cart successfully` }
                dispatch('notification/success', message, { root: true })
            } else {
                let message = { 'msg': res.data.message };
                dispatch('notification/error', message, { root: true })
            }
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Item to cart " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    editProductionOrderCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`productionorder_cart/${payload.id}`, payload).then((res) => {
            if (res.status == 200) {
                dispatch('fetchProductionOrderCart');
                let message = { 'msg': `Item ${payload.name} in cart updated successfully` }
                dispatch('notification/success', message, { root: true })
            } else {
                let message = { 'msg': res.data.message };
                dispatch('notification/error', message, { root: true })
            }
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error on updating Item in cart" }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteProductionOrderCart({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`productionorder_cart/${payload.id}`).then(() => {
            dispatch('fetchProductionOrderCart');
            let message = { 'msg': `Item ${payload.name} deleted from cart successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_RECIPE_CART', false)
            let message = { 'msg': "Error on deleting Item from cart " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Process order and Exit
    saveOrderExit({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`production_order`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchProductionOrderCart')
            if (response.status == 200) {
                let message = { 'msg': "Order Recorded successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to record Order" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchProductionOrderCart')
            let message = { 'msg': "Failed to record Order" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Production Orders
    fetchProductionOrders({ commit, dispatch }, payload) {
        commit('SET_FILTER_STATUS', true);
        let apiPayload = { ...payload };
        apiPayload.page = payload.page || 1;
        apiPayload.per_page = payload.per_page || 50;

        axios.get(`production_order`, {
            params: payload
        }).then(ec_res => {
            commit('SET_FILTER_STATUS', false);
            commit('SET_PRODUCTION_ORDERS', ec_res.data)
        }).catch(() => {
            commit('SET_PRODUCTION_ORDERS', { data: [], meta: {} });
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load production orders.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

    editProductionOrder({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`production_order/${payload.id}`, payload).then((res) => {
            if (res.status == 200) {
                dispatch('fetchProductionOrders', payload.filterOrders);
                let message = { 'msg': `Production order updated successfully` }
                dispatch('notification/success', message, { root: true })
            } else {
                let message = { 'msg': res.data.message };
                dispatch('notification/error', message, { root: true })
            }
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error on updating production order" }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteProductionOrder({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`production_order/${payload.id}`).then((res) => {
            if (res.status == 200) {
                dispatch('fetchProductionOrders', payload.filterOrders);
                let message = { 'msg': `Production order deleted successfully` }
                dispatch('notification/success', message, { root: true })
            } else {
                let message = { 'msg': res.data.message };
                dispatch('notification/error', message, { root: true })
            }
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_RECIPE_CART', false)
            let message = { 'msg': "Error on deleting production order " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
};